__turbopack_context__.v({
  "button": "ChartIntervalSelect-module__QajA6q__button",
  "buttonActive": "ChartIntervalSelect-module__QajA6q__buttonActive",
  "buttonGroup": "ChartIntervalSelect-module__QajA6q__buttonGroup",
  "select": "ChartIntervalSelect-module__QajA6q__select",
});
